import React, { useState, useRef, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet, HelmetProvider } from "react-helmet-async";

import Header from "./components/Header";
import FilterBar from "./components/FilterBar";
import AmenitiesSidebar from "./components/AmenitiesSidebar";
import Listings from "./components/Listings";
import Footer from "./components/Footer";

import MyListings from "./pages/MyListings";
import MyProfile from "./pages/MyProfile";
import EditProfile from "./pages/EditProfile";
import UserListings from "./pages/UserListings";
import MyFavorites from "./pages/MyFavorites";

import { Navigate } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import SignIn from "./pages/SignIn";
import AddListing from "./pages/AddListing";

import RenovationPage from "./pages/RenovationPage";
import AddRenovationListing from "./pages/AddRenovationListing";

import RenovationDetail from "./pages/RenovationDetail";

import SignUp from "./pages/SignUp";
import "leaflet/dist/leaflet.css";
import ListingDetail from "./pages/ListingDetail";
import "./App.css";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFail from "./pages/PaymentFail";
import bg from "./assets/back1.png";
import UsersList from "./components/UsersList";
import ListingUpgrade from "./pages/ListingUpgrade";
import PostingLimit from "./pages/PostingLimit";
import ListingPromotion from "./pages/ListingPromotion";
import TrialPopup from "./components/TrialPopup";

function HomePage() {
  const { t } = useTranslation();
 const { user } = useAuth();
  const navigate = useNavigate();


  const [filter, setFilter] = useState(() => {
  const saved = sessionStorage.getItem("listingFilters");
  return saved ? JSON.parse(saved) : {};
});
  const [selectedAmenities, setSelectedAmenities] = useState(() => {
  const saved = localStorage.getItem("selectedAmenities");

  return saved ? JSON.parse(saved) : [];
});
  const [displayCurrency, setDisplayCurrency] = useState("GEL");

  const [propertyType, setPropertyType] = useState("");
const [activeTab, setActiveTab] = useState("listings");
const [showAmenities, setShowAmenities] = useState(false);
const sidebarRef = useRef(null);



useEffect(() => {
  sessionStorage.setItem(
    "listingFilters",
    JSON.stringify(filter)
  );
}, [filter]);

useEffect(() => {
  const savedScroll = sessionStorage.getItem("listingScroll");

  if (savedScroll) {
    setTimeout(() => {
      window.scrollTo(0, Number(savedScroll));
    }, 50);
  }
}, []);


  const handleApply = (f) => {
    setFilter({ ...f, amenities: selectedAmenities });
  };

const handleSaveAmenities = () => {
  localStorage.setItem(
    "selectedAmenities",
    JSON.stringify(selectedAmenities)
  );
  setShowAmenities(false);
};

useEffect(() => {
  function handleClickOutside(event) {
    if (
      showAmenities &&
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target)
    ) {
      setShowAmenities(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showAmenities]);


  return (
   <>

<TrialPopup />

 <div className="hero-section"
 style={{ backgroundImage: `url(${bg})` }}
>

<Header section="realEstate" />

  <Helmet>
    <title>VIPart.ge – {t("home.title")}</title>
    <meta name="description" content={t("meta.description")} />
  </Helmet>


  <div className="home-intro">

  <h1>{t("home.title")}</h1>

  <p>{t("home.description")}</p>

  </div>


{/* 🔥 FILTER BAR FULL WIDTH */}
<FilterBar
  filter={filter}
  setFilter={setFilter}
  onApply={handleApply}
  displayCurrency={displayCurrency}
  setDisplayCurrency={setDisplayCurrency}
  propertyType={propertyType}
  setPropertyType={setPropertyType}
/>


</div>

   <div className="page-container">


<div
  className="amenities-toggle"
  onClick={() => setShowAmenities(v => !v)}
>
  {t("common.amenities")} {showAmenities ? "▲" : "▼"}
</div>

{/* 🔥 GRID: sidebar + listings */}
  <div className="filters-layout">

  <aside ref={sidebarRef} className={`left-sidebar ${showAmenities ? "open" : ""}`}>
<div className="left-sidebar-wrapper">
  <AmenitiesSidebar
    propertyType={propertyType}
    selectedAmenities={selectedAmenities}
    setSelectedAmenities={setSelectedAmenities}
  />
</div>

 <button
    className="save-amenities-btn"
    onClick={handleSaveAmenities}
  >
     {t("common.save")}
  </button>
</aside>

    <div className="right-content">
       
<div className="content-tabs">

  <button
    className={activeTab === "listings" ? "active" : ""}
    onClick={() => setActiveTab("listings")}
  >
     {t("tabs.listings")}
  </button>

  <button
  className={activeTab === "favorites" ? "active" : ""}
  onClick={() => {
    if (!user) {
      navigate("/signin");
      return;
    }

    setActiveTab("favorites");
  }}
>
  {t("tabs.favorites")}
</button>

  <button
    className={activeTab === "users" ? "active" : ""}
    onClick={() => setActiveTab("users")}
  >
     {t("tabs.users")}
  </button>

</div>


<div className="listings-container">
  <div className="listings-scroll">

{activeTab === "listings" && (
  <Listings
    filter={filter}
    displayCurrency={displayCurrency}
  />
)}

{activeTab === "favorites" && (
  <MyFavorites showHomeButton={false} />
)}

{activeTab === "users" && (
  <UsersList />
)}

   </div>
 </div>
  </div>
  </div>
  </div>
 </>
  );
}

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">Loading...</div>; // optional: spinner
  }

  return (
  <HelmetProvider>
    <Router>
      <div className="app-wrapper">

          <div className="main-content">

      <Routes>
        <Route path="/" element={<HomePage />} />

<Route
  path="/renovation"
  element={<RenovationPage />}
/>

        <Route path="/user/:userId" element={<UserListings />} />
        <Route path="/listing/:id" element={<ListingDetail />} />


<Route
  path="/payment-success"
  element={<PaymentSuccess />}
/>

<Route
  path="/payment-fail"
  element={<PaymentFail />}
/>

<Route
  path="/renovation/listing/:id"
  element={<RenovationDetail />}
/>

<Route
  path="/listing-upgrade"
  element={
    user
      ? <ListingUpgrade />
      : <Navigate to="/signin" />
  }
/>

<Route
    path="/listing-promotion"
    element={<ListingPromotion />}
/>

<Route
  path="/trial-ended"
  element={
    user
      ? <PostingLimit />
      : <Navigate to="/signin" />
  }
/>


        {/* Redirect logged-in users from auth pages */}
        <Route path="/signin" element={!user ? <SignIn /> : <Navigate to="/" />} />
        <Route
  path="/signup"
  element={
    !user
      ? <SignUp />
      : (
          <Navigate
            to={
              !user.accountType
                ? "/profile/edit"
                : "/"
            }
            replace
          />
        )
        }
        />
        <Route
         path="/favorites"
         element={user ? <MyFavorites /> : <Navigate to="/signin" />}
         />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />

        {/* Protected Routes */}
        <Route path="/add-listing" element={user ? <AddListing /> : <Navigate to="/signin" />} />

<Route
  path="/add-renovation"
  element={
    user
      ? <AddRenovationListing />
      : <Navigate to="/signin" />
  }
/>

        <Route path="/my-listings" element={user ? <MyListings /> : <Navigate to="/signin" />} />
        <Route path="/my-profile" element={user ? <MyProfile /> : <Navigate to="/signin" />} />
        <Route path="/profile/edit" element={user ? <EditProfile /> : <Navigate to="/signin" />} />
        <Route path="*" element={<NotFound />} />
       </Routes>
      </div>
      <Footer />
     </div>
    </Router>
  </HelmetProvider>
 );
}
